var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"variant":"outline"}},[_c('InfoIcon',{attrs:{"slot":"icon"},slot:"icon"}),_vm._v("\n  You don't have any profiles! Create one to get started.\n  "),_c('Button',{attrs:{"slot":"actions","variant":"flat","to":"/profile/new"},slot:"actions"},[_vm._v("Add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }